// extracted by mini-css-extract-plugin
export default {"title":"citizenships_title__0b5nU","actionButton":"citizenships_actionButton__KrI0g","disabledRow":"citizenships_disabledRow__5ViHn","button":"citizenships_button__w2xDV"};